let swiperShop;

function initSwiper() {
  if (window.innerWidth <= 1024) {
    // Tablet and mobile screen sizes
    if (!swiperShop) {
      // Check if Swiper is already initialized
      swiperShop = new Swiper(".swiper-shop", {
        loop: true,
        autoHeight: true,
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 20,

        breakpoints: {
          768: {
            slidesPerView: 1,
          },
        },

        // Navigation arrows
        navigation: {
          nextEl: ".shop-next",
          prevEl: ".shop-prev",
        },
      });
    }
  } else {
    if (swiperShop) {
      // Destroy Swiper if it exists
      swiperShop.destroy(true, true);
      swiperShop = null;
    }
  }
}

// Initialize Swiper on load and resize
initSwiper();
window.addEventListener("resize", initSwiper);

// Popup
document.addEventListener("DOMContentLoaded", function () {
  const triggerText = document.querySelector(".b-home-shop__trigger-text");
  const popupContainer = document.querySelector(
    ".b-home-shop__popup-container"
  );

  if (!triggerText || !popupContainer) return;

  // Create and style the overlay
  const overlay = document.createElement("div");
  overlay.classList.add("popup-overlay");
  document.body.appendChild(overlay);

  // Function to open the popup
  const openPopup = () => {
    popupContainer.style.display = "flex";
    overlay.style.display = "flex";
    document.body.style.overflow = "hidden"; // Disable page scroll
  };

  // Function to close the popup
  const closePopup = () => {
    popupContainer.style.display = "none";
    overlay.style.display = "none";
    document.body.style.overflow = ""; // Re-enable page scroll
  };

  // Event listeners
  triggerText.addEventListener("click", openPopup);
  overlay.addEventListener("click", closePopup);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closePopup();
  });
});

// Popup gallery
var swiperPopThumb = new Swiper(".swiper-pop-thumb", {
  loop: true,
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});
var swiperPopMain = new Swiper(".swiper-pop-main", {
  loop: true,
  spaceBetween: 10,
  effect: "creative",
  thumbs: {
    swiper: swiperPopThumb,
  },
});
